/**
 * @generated SignedSource<<331a8e20fbd9d2a81b2d41dfa21f3810>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { Fragment, ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type filterItem_navigationAppsSidebarCommon$data = {
  readonly filterId: string;
  readonly isEditable?: boolean | null | undefined;
  readonly isFavourite: boolean | null | undefined;
  readonly jql: string;
  readonly name: string;
  readonly " $fragmentType": "filterItem_navigationAppsSidebarCommon";
};
export type filterItem_navigationAppsSidebarCommon$key = {
  readonly " $data"?: filterItem_navigationAppsSidebarCommon$data;
  readonly " $fragmentSpreads": FragmentRefs<"filterItem_navigationAppsSidebarCommon">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "name": "filterItem_navigationAppsSidebarCommon",
  "selections": [
    {
      "kind": "ScalarField",
      "name": "filterId"
    },
    {
      "kind": "ScalarField",
      "name": "isFavourite"
    },
    {
      "kind": "ScalarField",
      "name": "jql"
    },
    {
      "kind": "ScalarField",
      "name": "name"
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "kind": "ScalarField",
          "name": "isEditable"
        }
      ],
      "type": "JiraCustomFilter"
    }
  ],
  "type": "JiraFilter",
  "abstractKey": "__isJiraFilter"
};

(node as any).hash = "31464d108113d7084e471c226c3fe0aa";

export default node;
